import { render } from "./CreateBucket.vue?vue&type=template&id=6a05f3cb&scoped=true"
import script from "./CreateBucket.vue?vue&type=script&lang=js"
export * from "./CreateBucket.vue?vue&type=script&lang=js"

import "./CreateBucket.vue?vue&type=style&index=0&id=6a05f3cb&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a05f3cb"]])

export default __exports__